module.exports = __webpack_public_path__ + "cfc554034cd06d73e3a71788f68af662.svg";